export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    id: "cat-1",
    name: "实用工具",
    slug: "tools",
    icon: "ri-tools-line",
    description: "精选高效实用的各类工具，提升工作与生活效率",
  },
  {
    id: "cat-2",
    name: "设计素材",
    slug: "design",
    icon: "ri-palette-line",
    description: "高质量设计资源与灵感素材，助力创意表达",
  },
  {
    id: "cat-3",
    name: "技术文章",
    slug: "tech",
    icon: "ri-code-s-slash-line",
    description: "深度技术干货与行业洞察，拓展技术视野",
  },
  {
    id: "cat-4",
    name: "学习资源",
    slug: "learning",
    icon: "ri-book-open-line",
    description: "优质学习资料与课程推荐，持续成长进阶",
  },
  {
    id: "cat-5",
    name: "效率提升",
    slug: "productivity",
    icon: "ri-rocket-line",
    description: "效率方法论与生产力工具，让工作事半功倍",
  },
  {
    id: "cat-6",
    name: "精品推荐",
    slug: "recommended",
    icon: "ri-star-line",
    description: "编辑精选的各类优质资源，不容错过的收藏之选",
  },
];